import { motion, useReducedMotion } from 'framer-motion';
import { cn } from 'noddi-ui-common';

export function ThreeDotsWave({ className }: { className?: string }) {
  const reduceMotion = useReducedMotion();
  if (reduceMotion) {
    return null;
  }

  return (
    <motion.div
      className={cn('flex size-8 justify-around', className)}
      variants={loadingContainerVariants}
      initial='start'
      animate='end'
    >
      <motion.span
        className='block size-1.5 rounded-full bg-primary'
        variants={loadingCircleVariants}
        transition={loadingCircleTransition}
      />
      <motion.span
        className='block size-1.5 rounded-full bg-primary'
        variants={loadingCircleVariants}
        transition={loadingCircleTransition}
      />
      <motion.span
        className='block size-1.5 rounded-full bg-primary'
        variants={loadingCircleVariants}
        transition={loadingCircleTransition}
      />
    </motion.div>
  );
}

const loadingContainerVariants = {
  start: {
    transition: {
      staggerChildren: 0.2
    }
  },
  end: {
    transition: {
      staggerChildren: 0.2
    }
  }
};

const loadingCircleVariants = {
  start: {
    y: '0%'
  },
  end: {
    y: '100%'
  }
};

const loadingCircleTransition = {
  duration: 0.5,
  repeat: Infinity,
  repeatType: 'reverse' as const,
  ease: 'easeInOut' as const
};
